import styled from 'styled-components';
var Footer = styled.footer.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-xzhmva-0"
})(["width:100%;height:92px;display:flex;align-items:center;background:var(--dentsu-color-n50);padding:var(--dentsu-spacing-24) var(--dentsu-spacing-32);z-index:1;"]);
var PrimaryActions = styled.div.withConfig({
  displayName: "Footerstyles__PrimaryActions",
  componentId: "sc-xzhmva-1"
})(["margin-right:0;"]);
var SecondaryActions = styled.div.withConfig({
  displayName: "Footerstyles__SecondaryActions",
  componentId: "sc-xzhmva-2"
})(["margin-right:auto;"]);
var TertiaryActions = styled.div.withConfig({
  displayName: "Footerstyles__TertiaryActions",
  componentId: "sc-xzhmva-3"
})(["margin-left:auto;margin-right:var(--dentsu-spacing-24);"]);
var NextButton = styled.div.withConfig({
  displayName: "Footerstyles__NextButton",
  componentId: "sc-xzhmva-4"
})(["display:flex;align-items:center;text-align:right;margin-left:var(--dentsu-spacing-16);&:hover{cursor:pointer;}&[disabled]{pointer-events:none;}"]);
var PrevButton = styled.div.withConfig({
  displayName: "Footerstyles__PrevButton",
  componentId: "sc-xzhmva-5"
})(["display:flex;align-items:center;text-align:left;&:hover{cursor:pointer;}&[disabled]{pointer-events:none;}"]);
var Label = styled.div.withConfig({
  displayName: "Footerstyles__Label",
  componentId: "sc-xzhmva-6"
})(["margin:auto var(--dentsu-spacing-12);"]);
var Overline = styled.div.withConfig({
  displayName: "Footerstyles__Overline",
  componentId: "sc-xzhmva-7"
})(["font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-12);color:var(--dentsu-color-n700);letter-spacing:var(--dentsu-tracking-wide);line-height:var(--dentsu-leading-none);text-transform:uppercase;margin:var(--dentsu-spacing-2) 0;opacity:", ";"], function (props) {
  return props.isDisabled ? 0.4 : 1;
});
var StepTitle = styled.div.withConfig({
  displayName: "Footerstyles__StepTitle",
  componentId: "sc-xzhmva-8"
})(["font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-16);color:var(--dentsu-color-n1000);line-height:var(--dentsu-leading-tight);text-overflow:ellipsis;overflow:hidden;white-space:nowrap;opacity:", ";"], function (props) {
  return props.isDisabled ? 0.4 : 1;
});
export var Styled = {
  Footer: Footer,
  PrimaryActions: PrimaryActions,
  SecondaryActions: SecondaryActions,
  TertiaryActions: TertiaryActions,
  NextButton: NextButton,
  PrevButton: PrevButton,
  Label: Label,
  Overline: Overline,
  StepTitle: StepTitle
};